import React, {useState, useEffect, useCallback} from 'react'
import { useTranslation } from 'react-i18next';
import { ArrowPathIcon, ArrowLongDownIcon, ArrowLongUpIcon, PlusCircleIcon, TagIcon, InformationCircleIcon, ScissorsIcon} from '@heroicons/react/24/outline';

import { v4 as uuidv4 } from 'uuid';
import { formatNumberWithCommas, formatFloat } from '../../../util/format-data';
import { 
  Tooltip ,
  Spinner,
  Input,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
} from '@material-tailwind/react';
import { useSelector } from 'react-redux';
import { getOp20TradeListByAddress, getOp20PSBTForSale, splitPsbt, getOp20TradeList, getOp20PSBTForBuy, op20BroadcastTransaction, getOp20TradeCheck, getOp20Indexer } from '../../../util/op20-api';
import { launchpadTokenRandom } from '../../../util/new-api';
import toast, { Toaster } from 'react-hot-toast';
import { debounce } from 'lodash';
import { getFeeRate } from '../../../util/inscribe-util';
import { op20FeeAddress } from '../../../configs/constant';
import { BitcoinNetworkType, signMessage, signTransaction } from 'sats-connect';
import { useWallet, useWallets } from '@wallet-standard/react';
import { sendPaymentTx } from '../../../util/api';
import { useNavigate } from 'react-router-dom';
import { getMezcalTradeList, getMezcalTradeListByAddress, getMezcalTradeCheck, saveMezcalTradeData, getMezcalPSBTForBuy, getMezcalTickerDetail, getMezcalPSBTForMezcalSplit, getMezcalPSBTForSplit } from '../../../util/mezcal-api';
import { strToHex } from '../../../util/format-data';
import FeeRateCardNew from '../../FeeRateCardNew';

export default function MezcalBuySellCard({ticker}) {
  const { t } = useTranslation();
  const price = useSelector(state => state.price);
  const wallet = useSelector(state => state.wallet);
  const feeRates = useSelector(state => state.feeRate);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
    return SatsConnectNamespace in wallet.features;
  }

  const [menu, setMenu] = useState(0);
  const [selected, setSelected] = useState(true);
  const [selectedAlkanesAmount, setSelectedAlkanesAmount] = useState(250000);
  const [sort, setSort] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [direct, setDirect] = useState(0);

  const [balanceData, setBalanceData] = useState([]);
  const [sellData, setSellData] = useState([]);
  const [sellTotal, setSellTotal] = useState(0);
  const [sellAmount, setSellAmount] = useState(0);
  const [selectedTotal, setSelectedTotal] = useState(0);
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [isRoyalty, setIsRoyalty] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [feerate, setFeerate] = useState(2);
  const [sliderValue, setSliderValue] = useState(0.1);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showInfo, setShowInfo] = useState(false);

  const [showSplit, setShowSplit] = useState(false);
  const [splitAmont, setSplitAmont] = useState(0);

  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];
  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [customFee, setCustomFee] = useState(0);
  const [sliderValueNew, setSliderValueNew] = useState(2);
  const [feerateNew, setFeerateNew] = useState(2);
  const [selectedSplitItem, setSelectedSplitItem] = useState(null);
  const [remainAmount, setRemainAmount] = useState(0);

  useEffect(() => {
    fetchBalance();
  }, [menu, refresh, wallet.nostrOrdinalsAddress]);

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setFeerate(Math.floor(value));
  }, [sliderValue, feeRates])

  const handleCustomFeeNew = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  useEffect(() => {

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerateNew(parseFloat(customFee));
        }
        else
        {
          setFeerateNew(feeRates[feeRateMode]);
          if (customFee == 0) 
          {
            setCustomFee(feeRates["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
  }, [feeRateMode, customFee, feeRates])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValueNew])

  useEffect(() => {
    if (menu == 0) {
      fetchSellData(1);
      setPage(1)
    }
  }, [refresh, menu, sort, direct])

  const fetchSellData = async(page) => {
    setLoading(true);

    let direction = direct == 0 ? "asc" : "desc";
    let order = sort == 0 ? "unitPrice" : "totalPrice";

    let result = await getMezcalTradeList(page, limit, ticker, order, direction);
    setTotal(Math.ceil(result.total / limit));
    if (page == 1) {
      setSellData(result.data);
    }
    else {
      setSellData([...sellData, ...result.data]);
    }
    
    setHasMore(result.total > page * limit);
    setPage(page + 1);
    setLoading(false);
  };

  const handleScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight * 1.5) {
      if (!loading && hasMore) {
        fetchSellData(page);
      }
    }
  }, [loading, hasMore]);

  const fetchBalance = async () => {
    setLoading(true);

    if (wallet.nostrOrdinalsAddress != "" && menu == 1) {
      const result = await getMezcalTradeListByAddress(ticker, wallet.nostrOrdinalsAddress);
      //const result = await getMezcalTradeListByAddress(ticker, "bc1qj6ll3gl9m4l35gxe6jt90d098y5vaqe68etu3v");
      
      setBalanceData(result);
    }

    // if (wallet.nostrOrdinalsAddress != "") {
    //   let royaltyResults = await launchpadTokenRandom(wallet.nostrOrdinalsAddress, 2) // opzero
    //   if (royaltyResults.data.length > 0) {
    //     setIsRoyalty(true);
    //   }
    //   else {
    //     setIsRoyalty(false);
    //   }
    // }
    setIsRoyalty(false);

    setLoading(false);
  }

  const handleOrder = (value) => {
    setSort(value);
    setDirect(direct == 1 ? 0 : 1);
  }

  const handleMenu = (value) => {
    setMenu(value);
  }

  const handleRefresh = () => {
    setRefresh(!refresh);
  }

  const handleChecked = async (index) => {
    setLoading(true);
    let res = await getMezcalTradeCheck(sellData[index].id);
    if (res.status == "success") {
      const newData = [...sellData];
      newData[index].checked = !newData[index].checked;
      setSellData(newData);
      setSellTotal(newData.filter(item => item.checked).reduce((acc, item) => acc + item.totalPrice, 0));
      setSellAmount(newData.filter(item => item.checked).reduce((acc, item) => acc + parseFloat(item.amount), 0));
    }
    else {
      setSellData(sellData.filter((_, i) => i !== index));
      toast.error(t('Selected item is already removed!'));
    }
    setLoading(false);
  }

  const handleCancel = (item) => {
    handleList(1, [item]); // cancel
  }

  const handleUnitPrice = (index, value) => {
    let tempBalanceData = [...balanceData];
    if (isNaN(parseFloat(value)))
    {
      tempBalanceData[index].unitPrice = null;
      tempBalanceData[index].totalPrice = null;
      tempBalanceData[index].actualPrice = null;
      tempBalanceData[index].checked = false;
    } 
    else {
      tempBalanceData[index].unitPrice = parseFloat(value);
      tempBalanceData[index].totalPrice = Math.ceil(parseFloat(value) * parseFloat(tempBalanceData[index].amount));

      let marketplaceFee = 0;
      if (isRoyalty) {
        marketplaceFee = 1000;
      }
      else {
        marketplaceFee = 1000;
        if (tempBalanceData[index].totalPrice * 0.025 > marketplaceFee) {
          marketplaceFee = Math.floor(tempBalanceData[index].totalPrice * 0.025);
        }
      }

      tempBalanceData[index].actualPrice = tempBalanceData[index].totalPrice - marketplaceFee;
      
      if (tempBalanceData[index].totalPrice < 10000) {
        tempBalanceData[index].error = t('Minimum item is 10000 sats');
        tempBalanceData[index].checked = false;
      }
      else {
        tempBalanceData[index].error = "";
        tempBalanceData[index].checked = true;
      }
    }
    setBalanceData(tempBalanceData);
    setSelectedTotal(tempBalanceData.filter(item => item.checked).reduce((acc, item) => acc + item.actualPrice, 0));
    setSelectedAmount(tempBalanceData.filter(item => item.checked).reduce((acc, item) => acc + parseFloat(item.amount), 0));
  } 

  const prepareList = async () => {
    let tempItems = balanceData.filter(item => item.checked);
    if (tempItems.length == 0) {
      toast.error(t('Please select at least one item'));
      return;
    }

    let flag = false;
    for(let item of tempItems) {
      if (item.balances.length > 1) {
        flag = true;
        break;
      }
    }
    
    setSelectedItems(tempItems);

    if (flag) {
      setShowInfo(true);
      return;
    }

    setShowInfo(false);
    handleList(0, tempItems);
  }

  const handleList = async (type, selectedItems) => {
    setLoading(true);
    let data = [];
    if (type == 1) { // cancel
      for(let item of selectedItems) {
        data.push({
          txid: item.txId.split(":")[0],
          vout: item.vout,
          value: item.value,
          actualPrice: 10000 * Math.pow(10, 8)
        });
      }
    }
    else if (type == 0) { // list
      for(let item of selectedItems) {
        data.push({
          txid: item.txId.split(":")[0],
          vout: item.vout,
          value: item.value,
          actualPrice: item.actualPrice,
        })
      }
    }

    let params = {
      ordinalPubkey: wallet.ordinalsPublicKey,
      ordinalAddress: wallet.nostrOrdinalsAddress,
      paymentAddress: wallet.nostrPaymentAddress,
      datas: data,
      provider: wallet.domain
    }

    let psbt = await getOp20PSBTForSale(params);
    let signedPsbt;

    try{
      if (wallet.domain == "unisat") {
        signedPsbt = await window.unisat.signPsbt(psbt.psbt);
      }
      else if (wallet.domain == "tapwallet") {
        signedPsbt = await window.tapwallet.signPsbt(psbt.psbt);
      }
      else if (wallet.domain == "okxwallet") {
        signedPsbt = await window.okxwallet.bitcoin.signPsbt(psbt.psbt);
      }
      else if (wallet.domain == "magiceden") {
        let signIndexes = [];

        for(let i=0;i<data.length; i++){
          signIndexes.push(i);
        }

        let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

        await signTransaction({
          getProvider: async () =>
            magicedenWallets[0].features['sats-connect:'].provider,
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: psbt.psbt,
              broadcast: false,
              message: "Sign Transaction",
              inputsToSign: [
                  {
                      address: wallet.nostrOrdinalsAddress,
                      signingIndexes: signIndexes,
                      sigHash: 131
                  },
              ],
          },
          onFinish: async (response) => {  
            signedPsbt = response.psbtBase64;

            const { signedPsbtData, unsignedPsbtData } = await splitPsbt({signedHex: signedPsbt, unsignedHex: psbt.psbt});

            let updatedData = [];
            if (type == 1) { // cancel
              for(let i = 0; i< selectedItems.length; i++) {
                updatedData.push({
                  id: selectedItems[i].tradeId,
                  signedPsbt: signedPsbtData.hexArray[i]
                })
              }
            }
            else if (type == 0) { // list
              for(let i = 0; i< selectedItems.length; i++) {
                updatedData.push({
                  ticker: ticker,
                  name: selectedItems[i].name,
                  amount: parseFloat(selectedItems[i].amount),
                  unitPrice: selectedItems[i].unitPrice,
                  actualPrice: selectedItems[i].actualPrice,
                  totalPrice: selectedItems[i].totalPrice,
                  ownerAddress: wallet.nostrOrdinalsAddress,
                  utxoTxId: selectedItems[i].txId,
                  utxoVout: selectedItems[i].vout,
                  utxoValue: selectedItems[i].value,
                  psbt: unsignedPsbtData.hexArray[i],
                  signedPsbt: signedPsbtData.hexArray[i]
                })
              }
            }

            if (type == 1) {
              let results = await saveMezcalTradeData({type: "delist", datas: updatedData});
              if (results.status == "success") {
                toast.success(t('Successfully canceled'));
                handleRefresh();
              }
              else {
                toast.error(t('Failed to cancel'));
              }
            }
            else if (type == 0) {
              let results = await saveMezcalTradeData({type: "list", datas: updatedData});
              if (results.status == "success") {
                toast.success(t('Successfully listed'));
                handleRefresh();
              }
              else {
                toast.error(t('Failed to list'));
              }
            }

            setLoading(false);
          },
          onCancel: () => {
            toast.error(t('Request canceled'));
            setLoading(false);
            return;
          },
        });
        return;
      }
      else if (wallet.domain == "xverseWallet") {
        let signIndexes = [];

        for(let i=0;i<data.length; i++){
          signIndexes.push(i);
        }

        await signTransaction({
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: psbt.psbt,
              broadcast: false,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                      address: wallet.nostrOrdinalsAddress,
                      signingIndexes: signIndexes,
                      sigHash: 131
                  },
              ],
          },
          onFinish: async (response) => {  
            signedPsbt = response.psbtBase64;

            const { signedPsbtData, unsignedPsbtData } = await splitPsbt({signedHex: signedPsbt, unsignedHex: psbt.psbt});

            let updatedData = [];
            if (type == 1) { // cancel
              for(let i = 0; i< selectedItems.length; i++) {
                updatedData.push({
                  id: selectedItems[i].tradeId,
                  signedPsbt: signedPsbtData.hexArray[i]
                })
              }
            }
            else if (type == 0) { // list
              for(let i = 0; i< selectedItems.length; i++) {
                updatedData.push({
                  ticker: ticker,
                  name: selectedItems[i].name,
                  amount: parseFloat(selectedItems[i].amount),
                  unitPrice: selectedItems[i].unitPrice,
                  actualPrice: selectedItems[i].actualPrice,
                  totalPrice: selectedItems[i].totalPrice,
                  ownerAddress: wallet.nostrOrdinalsAddress,
                  utxoTxId: selectedItems[i].txId,
                  utxoVout: selectedItems[i].vout,
                  utxoValue: selectedItems[i].value,
                  psbt: unsignedPsbtData.hexArray[i],
                  signedPsbt: signedPsbtData.hexArray[i]
                })
              }
            }

            if (type == 1) {
              let results = await saveMezcalTradeData({type: "delist", datas: updatedData});
              if (results.status == "success") {
                toast.success(t('Successfully canceled'));
                handleRefresh();
              }
              else {
                toast.error(t('Failed to cancel'));
              }
            }
            else if (type == 0) {
              let results = await saveMezcalTradeData({type: "list", datas: updatedData});
              if (results.status == "success") {
                toast.success(t('Successfully listed'));
                handleRefresh();
              }
              else {
                toast.error(t('Failed to list'));
              }
            }

            setLoading(false);
          },
          onCancel: () => {
            toast.error(t('User Reject Request Error Message'))
            setLoading(false);
            return;
          },
        });
        return;
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      setLoading(false);
      return
    }

    const { signedPsbtData, unsignedPsbtData } = await splitPsbt({signedHex: signedPsbt, unsignedHex: psbt.psbt});

    let updatedData = [];
    if (type == 1) { // cancel
      for(let i = 0; i< selectedItems.length; i++) {
        updatedData.push({
          id: selectedItems[i].tradeId,
          signedPsbt: signedPsbtData.hexArray[i]
        })
      }
    }
    else if (type == 0) { // list
      for(let i = 0; i< selectedItems.length; i++) {
        updatedData.push({
          ticker: ticker,
          name: selectedItems[i].name,
          amount: parseFloat(selectedItems[i].amount),
          unitPrice: selectedItems[i].unitPrice,
          actualPrice: selectedItems[i].actualPrice,
          totalPrice: selectedItems[i].totalPrice,
          ownerAddress: wallet.nostrOrdinalsAddress,
          utxoTxId: selectedItems[i].txId,
          utxoVout: selectedItems[i].vout,
          utxoValue: selectedItems[i].value,
          psbt: unsignedPsbtData.hexArray[i],
          signedPsbt: signedPsbtData.hexArray[i]
        })
      }
    }

    if (type == 1) {
      let results = await saveMezcalTradeData({type: "delist", datas: updatedData});
      if (results.status == "success") {
        toast.success(t('Successfully canceled'));
        handleRefresh();
      }
      else {
        toast.error(t('Failed to cancel'));
      }
    }
    else if (type == 0) {
      let results = await saveMezcalTradeData({type: "list", datas: updatedData});
      if (results.status == "success") {
        toast.success(t('Successfully listed'));
        handleRefresh();
      }
      else {
        toast.error(t('Failed to list'));
      }
    }

    setLoading(false);
  }

  const handleBuy = async () => {
    setLoading(true);

    if (wallet.nostrOrdinalsAddress == "") {
      toast.error(t('Please connect your wallet'));
      setLoading(false);
      return;
    }

    let selectedItems = sellData.filter(item => item.checked);
    let totalFee = 0;
    let totalPrice = 0;
    let totalAmount = 0;

    if (selectedItems.length == 0) {
      toast.error(t('Please select at least one item'));
      setLoading(false);
      return;
    }

    for(let item of selectedItems) {
      totalPrice += item.totalPrice;
      totalAmount += parseFloat(item.amount);
    }

    if (isRoyalty) {
      totalFee = 1000;
    }
    else {
      totalFee = 1000;
      if (totalPrice * 0.025 > totalFee) {
        totalFee = Math.floor(totalPrice * 0.025);
      }
    }
    
    let tempFeerate = parseFloat(feerate);
    if (isNaN(tempFeerate)) {
      tempFeerate = 1.2;
    }
    if (tempFeerate <= 1.1) {
      tempFeerate = 1.2;
    }

    let tickerDetail = await getMezcalTickerDetail(ticker);
    if (tickerDetail.status == "fail") {
      toast.error(t('Ticker not found'));
      setLoading(false);
      return;
    }

    let decimals = tickerDetail.data.decimals;
    let text = `{"p":"https://mezcal.sh","edicts":[["${ticker}","${totalAmount * Math.pow(10, decimals)}",0]]}`
    console.log("----text----", text);

    let params = {
      datas: selectedItems,
      provider: wallet.domain,
      paymentPubkey: wallet.paymentPublicKey,
      paymentAddress: wallet.nostrPaymentAddress,
      ordinalAddress: wallet.nostrOrdinalsAddress,
      feerate: tempFeerate,
      fundingAddress: op20FeeAddress,
      totalFee: totalFee,
      key: strToHex(text)
    }

    let psbt = await getMezcalPSBTForBuy(params);

    if (psbt.status == "fail") {
      if (psbt.message == "Item already sold!") {
        toast.error(t('Item already sold! Plesse try again.'));
      }
      else {
        toast.error(t('Insufficient balance'));
      }
      setLoading(false);
      handleRefresh();
      return;
    }

    let signedPsbt;
    let txid;

    try{
      if (wallet.domain == "unisat") {
        signedPsbt = await window.unisat.signPsbt(psbt.psbt);
        txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "tapwallet") {
        signedPsbt = await window.tapwallet.signPsbt(psbt.psbt);
        txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        signedPsbt = await window.okxwallet.bitcoin.signPsbt(psbt.psbt);
        txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "magiceden") {
        let signIndexes = [];
        for(let i=0;i<1; i++){
          signIndexes.push(i);
        }
        
        for(let i=selectedItems.length + 1; i < selectedItems.length + psbt.count; i++) {
          signIndexes.push(i);
        }

        let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

        await signTransaction({
          getProvider: async () =>
            magicedenWallets[0].features['sats-connect:'].provider,
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: psbt.psbt,
              broadcast: false,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                    address: wallet.nostrPaymentAddress,
                    signingIndexes: signIndexes
                  },
              ],
          },
          onFinish: async (response) => {  
            let res = await sendPaymentTx(response.psbtBase64, signIndexes);
            for(let item of selectedItems) {
              item.txId = res.txid;
              item.receiverAddress = wallet.nostrOrdinalsAddress;
            }
        
            let buyParams = {
              datas: selectedItems,
              type: "buy"
            }
        
            await saveMezcalTradeData(buyParams);
        
            toast.success(t('Successfully broadcasted.'));
            handleRefresh();
            setLoading(false);
            return;
          },
          onCancel: () => {
            toast.error(t('Request canceled'));
            setLoading(false);
            return;
          },
        });
        return;
      }
      else if (wallet.domain == "xverseWallet") {
        let signIndexes = [];
        for(let i=0;i<1; i++){
          signIndexes.push(i);
        }
        
        for(let i=selectedItems.length + 1; i < selectedItems.length + psbt.count; i++) {
          signIndexes.push(i);
        }

        await signTransaction({
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: psbt.psbt,
              broadcast: false,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                    address: wallet.nostrPaymentAddress,
                    signingIndexes: signIndexes
                  },
              ],
          },
          onFinish: async (response) => {  
            let res = await sendPaymentTx(response.psbtBase64, signIndexes);
            for(let item of selectedItems) {
              item.txId = res.txid;
              item.receiverAddress = wallet.nostrOrdinalsAddress;
            }
        
            let buyParams = {
              datas: selectedItems,
              type: "buy"
            }
        
            await saveMezcalTradeData(buyParams);
        
            toast.success(t('Successfully broadcasted.'));
            handleRefresh();
            setLoading(false);
            return;
          },
          onCancel: () => {
            toast.error(t('User Reject Request Error Message'))
            setLoading(false);
            return;
          },
        });

        return;
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      setLoading(false);
      return
    }

    for(let item of selectedItems) {
      item.txId = txid;
      item.receiverAddress = wallet.nostrOrdinalsAddress;
    }

    let buyParams = {
      datas: selectedItems,
      type: "buy"
    }

    await saveMezcalTradeData(buyParams);

    toast.success(t('Successfully broadcasted.'));
    handleRefresh();
    setLoading(false);
  }

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setFeerate(sanitizedValue);
  }

  const handleMezcalSplit = async (item) => {
    setLoading(true);
    console.log("----item----", item);
    let text = `{"p":"https://mezcal.sh","edicts":[["${item.ticker}","${item.amount * Math.pow(10, item.decimals)}",1]]}`
    
    console.log("----text----", text);

    let tempFeerate = parseFloat(feeRates["Fast"]);
    if (isNaN(tempFeerate)) {
      tempFeerate = 1.2;
    }
    if (tempFeerate <= 1.1) {
      tempFeerate = 1.2;
    }
    
    let paramUtxos = {
      paymentAddress: wallet.nostrPaymentAddress, 
      fundingAddress: op20FeeAddress, 
      fundingAmount: 1000, 
      paymentPubkey: wallet.paymentPublicKey, 
      feeRate: tempFeerate, 
      provider: wallet.domain, 
      balanceUtxos: [item],
      receiverAddress: wallet.nostrOrdinalsAddress,
      ordinalAddress: wallet.nostrOrdinalsAddress,
      key: strToHex(text)
    }

    let paymentUtxos = await getMezcalPSBTForMezcalSplit(paramUtxos)
    let isSuccess = true;

    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      return;
    }

    if (isSuccess) {
      toast.success(t('Success Split Message'));
      handleRefresh();
      setLoading(false);
    }
  }

  const handleSplitAmount = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setSplitAmont(sanitizedValue);
  }

  useEffect(() => {
    let parsedAmount = parseFloat(splitAmont);
    if (isNaN(parsedAmount)) {
      parsedAmount = 0;
    }
    setRemainAmount(Math.round((selectedSplitItem?.amount - parsedAmount) * Math.pow(10, selectedSplitItem?.decimals)) / Math.pow(10, selectedSplitItem?.decimals));
  }, [selectedSplitItem, splitAmont]);

  const handleSplit = async () => {
    if (isNaN(parseFloat(splitAmont)) || parseFloat(splitAmont) <= 0 || parseFloat(splitAmont) > selectedSplitItem?.amount) {
      toast.error(t('Insert valid amount'));
      setShowSplit(false);
      return;
    }

    setLoading(true);
    setShowSplit(false);

    let text = `{"p":"https://mezcal.sh","edicts":[["${selectedSplitItem.ticker}","${parseFloat(splitAmont) * Math.pow(10, selectedSplitItem.decimals)}",1]]}`

    let tempFeerate = parseFloat(feerateNew);
    if (isNaN(tempFeerate)) {
      tempFeerate = 1.2;
    }
    if (tempFeerate <= 1.1) {
      tempFeerate = 1.2;
    }
    
    let paramUtxos = {
      paymentAddress: wallet.nostrPaymentAddress, 
      fundingAddress: op20FeeAddress, 
      fundingAmount: 1000, 
      paymentPubkey: wallet.paymentPublicKey, 
      feeRate: tempFeerate, 
      provider: wallet.domain, 
      balanceUtxos: [selectedSplitItem],
      receiverAddress: wallet.nostrOrdinalsAddress,
      ordinalAddress: wallet.nostrOrdinalsAddress,
      key: strToHex(text)
    }

    let paymentUtxos = await getMezcalPSBTForMezcalSplit(paramUtxos)
    let isSuccess = true;

    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      return;
    }

    if (isSuccess) {
      toast.success(t('Success Split Message'));
      handleRefresh();
      setLoading(false);
    }
  }

  return (
    <div className="md:w-[450px] md:min-w-[450px] w-full flex flex-col gap-3 rounded-md bg-background2 sm:h-[calc(100vh-110px)] h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      <div className="flex flex-row border-b-[1px] border-background1 p-4">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row gap-8 items-center">
            <div className={`cursor-pointer hover:text-primary font-bold transition-all duration-100 ease-in-out ${menu == 0 ? "text-white text-3xl border-b-2 border-primary" : "text-gray-400 text-2xl"} `} onClick={()=> handleMenu(0)}>{t('Buy')}</div>
            <div className={`cursor-pointer hover:text-primary font-bold transition-all duration-100 ease-in-out ${menu == 1 ? "text-white text-3xl border-b-2 border-primary" : "text-gray-400 text-2xl"}`} onClick={()=> handleMenu(1)}>{t('Sell')}</div>
          </div>
          <Tooltip content={t('Refresh')}>
            <div className="cursor-pointer" onClick={() => handleRefresh()}><ArrowPathIcon strokeWidth={2} className="h-5 w-5" /></div>
          </Tooltip>
        </div>
        
      </div>
      {
        menu == 0 ?
        <div className="text-gray-400 flex flex-row gap-2 p-3 border-b-[1px] border-background1">
          <div className="sm:w-[40%] w-[50%]">{t('Quantity')}</div>
          <div className="sm:w-[30%] sm:flex hidden flex-row gap-1 items-center justify-end">
            <span>{t('Price')} (sats)</span>
            <div className="flex flex-row cursor-pointer" onClick={() => handleOrder(0)}>
              <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 0 && direct == 1 ? 'text-primary' : 'text-white'}`} />
              <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 0 && direct == 0 ? 'text-primary' : 'text-white'}`} />
            </div>
          </div>
          <div className="sm:w-[30%] w-[50%] flex flex-row gap-1 items-center justify-end">
            <span>{t('Total')} (BTC)</span>
            <div className="flex flex-row cursor-pointer" onClick={() => handleOrder(1)}>
              <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 1 && direct == 1 ? 'text-primary' : 'text-white'}`} />
              <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 1 && direct == 0 ? 'text-primary' : 'text-white'}`} />
            </div>
          </div>
        </div>
        :
        <div className="flex flex-col gap-2 w-full">
          {/* <div className="flex flex-row gap-2 justify-end px-2">
            <div className=" px-3 py-2 text-white bg-primary rounded-md hover:bg-primary-hover cursor-pointer" onClick={() => navigate(`/inscribe/op_return/transfer/${ticker}`)}>{t('Transfer (Creates UTXO)')}</div>
          </div> */}
          <div className="text-gray-400 flex flex-row gap-2 p-3 border-b-[1px]  border-background1">
            <div className="w-[50%]">{t('Quantity')}</div>
            <div className="w-[50%] flex flex-row gap-1 items-center justify-end">
              <span>{t('Price')} (sats)</span>
            </div>
          </div>
        </div>
      }
      {
        menu == 0 ?
        <div className="flex flex-col h-full overflow-y-auto" onScroll={handleScroll}>
          
          {
            sellData.map((item, index) => (
              <div key={index} className="flex flex-row gap-2 p-3 border-b-[1px] border-background1 cursor-pointer hover:bg-background1 transition-all duration-100 ease-in-out h-[80px]" onClick={() => handleChecked(index)}>
                <div className="sm:w-[40%] w-[50%] flex flex-row gap-1 items-center">
                  <div className="cursor-pointer">
                    {
                      item?.checked ? 
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-primary">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                      :
                      <PlusCircleIcon strokeWidth={2} className="h-6 w-6 text-white" />
                    }
                  </div>
                  <span>{formatNumberWithCommas(parseFloat(item.amount))}</span>
                </div>
                <div className="sm:w-[30%] hidden sm:flex flex-col text-right">
                  <span>{item.unitPrice}</span>
                  <span className="text-gray-400">${formatFloat(item.unitPrice * price.bitcoin / Math.pow(10, 8), 4)}</span>
                </div>
                <div className="sm:w-[30%] w-[50%] flex flex-col text-right">
                  <span>{item.totalPrice / Math.pow(10, 8)} BTC</span>
                  <span className="text-gray-400">${formatFloat(item.totalPrice / Math.pow(10, 8) * price.bitcoin, 2)}</span>
                </div>
              </div>
            ))
          }
        </div>
        :
        <div className="flex flex-col h-full overflow-y-auto">
          {
            wallet.nostrOrdinalsAddress != "" ?
            balanceData.map((item, index) => (
              <div key={item.txId} className="flex flex-row gap-2 p-3 border-b-[1px] border-background1 hover:bg-background1 transition-all duration-100 ease-in-out">
                <div className="w-[50%] flex flex-row gap-1 items-center">
                  <div className="cursor-pointer">
                    {
                      item.tradeId ?
                      <>
                        <TagIcon strokeWidth={2} className="size-6 text-white" />
                      </>
                      :
                      <>
                        {
                          item?.checked ? 
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-primary">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                          </svg>
                          :
                          <PlusCircleIcon strokeWidth={2} className="h-6 w-6 text-white" />
                        }
                      </>
                    }
                  </div>
                  {
                    item.tradeId ?
                    <div className="flex flex-col gap-1">
                      <span>{formatNumberWithCommas(parseFloat(item.amount))}</span>
                      <span className="text-gray-400 text-[12px]">{t('Sell at')}&nbsp;{item.unitPrice} sats</span>
                    </div>
                    :
                    <div className="flex flex-row gap-1 items-center">
                      <span>{formatNumberWithCommas(parseFloat(item.amount))}</span>
                      {
                        item.balances.length > 1 ?
                        <>
                          <Tooltip content={item.balances.map(balance => balance.name + " (" + balance.amount + ")").join(", ")}>
                            <InformationCircleIcon strokeWidth={2} className="h-5 w-5 text-red-500 cursor-pointer" />
                          </Tooltip>
                          <Tooltip content={t('Separate Mezcal from shared UTXO')}>
                            <ScissorsIcon strokeWidth={2} className="h-5 w-5 text-blue-500 cursor-pointer" onClick={() => handleMezcalSplit(item)}/>
                          </Tooltip>
                        </>
                        :
                        <Tooltip content={t('Split Mezcal into smaller amounts')}>
                          <ScissorsIcon strokeWidth={2} className="h-5 w-5 text-primary cursor-pointer" onClick={() => {setShowSplit(true); setSelectedSplitItem(item);}}/>
                        </Tooltip>
                      }
                    </div>
                  }
                </div>
                {
                  item.tradeId ?
                  <div className="w-[50%] flex flex-col items-end gap-1">
                    <div className="px-4 py-[6px] text-white bg-gray-800 rounded-md cursor-pointer hover:bg-gray-700 transition-all duration-100 ease-in-out" onClick = {() => handleCancel(item)}>
                      {t('Cancel')}
                    </div>
                    <div className="flex flex-row gap-1 text-[12px]">
                      <span>{item.totalPrice / Math.pow(10, 8)} BTC •</span>
                      <span className="text-gray-400">${formatFloat(item.totalPrice * price.bitcoin / Math.pow(10, 8), 4)}</span>
                    </div>
                  </div>
                  :
                  <div className="w-[50%] flex flex-col items-end gap-1">
                    <Input label={t('Unit Price in sats')} type="number" color="white" value={item.unitPrice} onChange={(e) => { handleUnitPrice(index, e.target.value)}}/>
                    {
                      item.totalPrice ?
                      <div className="flex flex-col gap-1 text-[12px]">
                        <div className="flex flex-row gap-1">
                          <span>{item.totalPrice / Math.pow(10, 8)} BTC •</span>
                          <span className="text-gray-400">${formatFloat(item.totalPrice * price.bitcoin / Math.pow(10, 8), 4)}</span>
                        </div>
                        {
                          item.error != "" ?
                          <span className="text-red-500">{item.error}</span>
                          :
                          <></>
                        }
                      </div>
                      :
                      <></>
                    }
                  </div>
                }
              </div>
            ))
            :
            <div className="flex flex-row justify-center text-gray-400 text-lg mt-3">{t('Please connect your wallet')}</div>
          }
        </div>
      }
      {
        menu == 0 ?
        <div className="flex flex-col gap-2 h-[200px] border-t-[1px] border-background1 p-2">

          <div className="flex flex-row justify-between items-center text-white text-xl">
            <div>{t('You Pay')}</div>
            <div>{sellTotal / Math.pow(10, 8)} BTC</div>
          </div>
          <div className="flex flex-row gap-3 items-center mt-2">
              <Slider className= "sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
              <div className="sm:max-w-[200px] w-full">
                <Input type="text" color="white" label = "Custom Fee" className="sm:max-w-[200px] w-full" value={feerate} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
              </div>
            </div>
          {
            sellAmount > 0 ? 
            <div className="flex flex-col gap-1">
              <div className="px-4 py-2 text-white bg-primary hover:bg-primary-hover rounded-md cursor-pointer text-center font-bold" disabled={loading} onClick={() => handleBuy()}>{t('Buy')} {formatNumberWithCommas(sellAmount)}</div> 
            </div> 
            : 
            <div className="flex flex-row justify-center text-gray-400 text-lg">{t('Select Items to Buy')}</div>
          }
        </div>
        :
        <div className="flex flex-col gap-2 h-[120px] border-t-[1px] border-background1 p-2">
          <div className="flex flex-row justify-between items-center text-white text-xl">
            <div>{t('You Receive')}</div>
            <div>{selectedTotal / Math.pow(10, 8)} BTC</div>
          </div>
          <div className="px-4 py-2 text-white bg-primary hover:bg-primary-hover rounded-md cursor-pointer text-center font-bold" disabled={loading} onClick={() => prepareList()}>{t('List')} {formatNumberWithCommas(selectedAmount)}</div> 
        </div>
      }
      <Dialog
        open={showInfo}
        size={"xs"}
        className="bg-black border-solid border-[1px] border-gray-600"
      >
        <DialogBody>
          <div className="flex flex-col justify-center w-full gap-3 p-3 sm:max-h-full max-h-[500px] overflow-y-auto">
            <div className="flex flex-row text-center justify-center items-center w-full text-primary gap-1">
              <InformationCircleIcon strokeWidth={2} className="h-12 w-12" />
            </div>
            <div className="text-center text-white">
              {t('Mezcal Utxo Warning Message')}
            </div>
          </div>
          <div className="flex flex-row gap-4 justify-center w-full mt-2">
            <Button  onClick={() => { handleList(0, selectedItems); setShowInfo(false); }} color="pink">{t('PROCEED')}</Button>
            <Button  onClick={() => setShowInfo(false)}>{t('CANCEL')}</Button>
          </div>
        </DialogBody>
      </Dialog>
      <Dialog
        open={showSplit}
        size={"xs"}
        className="bg-black border-solid border-[1px] border-gray-600"
      >
        <DialogBody>
          <div className="flex flex-col justify-center w-full gap-3 p-3 sm:max-h-full max-h-[500px] overflow-y-auto">
            <div className="flex flex-row gap-2 items-center justify-center mb-5">
              <ScissorsIcon strokeWidth={2} className="h-12 w-12 text-primary" />
              <div className="text-primary font-bold text-2xl">
                {t('SPLIT')}
              </div>
            </div>
            <Input type="number" color="white" label = {t('Split Amount')} className="w-full md:min-w-[400px] min-w-[250px]" value={splitAmont} onChange = {(e) => {handleSplitAmount(e.target.value)}}/>
            <div className="flex flex-row text-white">
              {
                remainAmount > 0 ?
                <div className="text-white">
                  {t('Remain Amount')}: {remainAmount}
                </div>
                :
                <div className="text-red-500">
                  {t('Split amount exceed the balance')}
                </div>
              }
            </div>

            <div className="text-left w-full text-gray-400 mt-2 sm:text-[16px] text-[14px]">
              {t('Select Network Fee You Want')}:
            </div>
            <div className="grid grid-cols-3 gap-3 w-full mt-3">
              <FeeRateCardNew header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
              <FeeRateCardNew header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
              <FeeRateCardNew header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
            </div>
            {
              feeRateMode == "Custom" ? 
              <div className="flex flex-row gap-3 items-center mt-2">
                <Slider className= "sm:flex hidden" color="blue" value = {sliderValueNew} onChange = {(e) => setSliderValueNew(e.target.value)}/>
                <div className="sm:max-w-[200px] w-full">
                  <Input type="text" color="white" label = "Custom Fee" className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFeeNew(e.target.value)}}/>
                </div>
              </div>
              : 
              <></>
            }

            <div className="flex flex-row gap-4 justify-center w-full mt-2">
              <div className="px-8 py-2 text-white bg-primary hover:bg-primary-hover rounded-md cursor-pointer text-center font-bold" onClick={() => { handleSplit(); }}>{t('SPLIT')}</div>
              <div className="px-6 py-2 text-white bg-gray-900 hover:bg-gray-800 rounded-md cursor-pointer text-center font-bold" onClick={() => { setShowSplit(false); }}>{t('CANCEL')}</div>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </div>
  )
}
